export default "__VITE_ASSET__DIrxA$Lp__"